import Row from '@components/row'
import {
  StyleColumn,
  StyleCard,
  StyleLeftWrapper,
  StyleRightWrapper,
  StyleTag,
} from './style'
import Typography from '@components/typography'
import Image from '@components/image'
import Column from '@components/column'
import Button from '@components/button'
import Svg from '@components/svg'
import ScheduleCard from '@commons/cards/schedule'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { differenceInMinutes } from 'date-fns'
const NextScheduleAppointment = () => {
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )
  const handleClickMessage = () => {
    const receiver = {
      id: appointmentConsultDashboard?.nextScheduleAppointment?.patient?.id,
      name: appointmentConsultDashboard?.nextScheduleAppointment?.patient?.name,
      avatar:
        appointmentConsultDashboard?.nextScheduleAppointment?.patient?.avatar,
    }
    navigate(`/${user?.role}/chats`, {
      state: {
        receiver,
      },
    })
  }
  const handleClickViewDetails = () => {
    navigate(
      `/${user?.role}/appointments/details-${appointmentConsultDashboard?.nextScheduleAppointment?.id}`,
    )
  }

  const start = new Date(
    appointmentConsultDashboard?.nextScheduleAppointment?.createdAt,
  )
  const end = new Date()
  const isExpired = end > start
  const totalMinutes = differenceInMinutes(end, start)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  const duration = `${hours}hr ${minutes}min`

  return (
    <>
      {!!appointmentConsultDashboard?.nextScheduleAppointment?.id ? (
        <StyleColumn>
          <Row alignItems="center" colGap={2}>
            <Typography content="New Appointment in:" size={14} />
            <Typography
              content={!!isExpired ? 'Expired' : duration}
              size={14}
              tc={!!isExpired ? 'danger' : 'secondary'}
            />
          </Row>
          <StyleCard>
            <StyleLeftWrapper>
              <Image
                src={`${process.env.BUCKET_URL}/${appointmentConsultDashboard?.nextScheduleAppointment?.user?.avatar}`}
                fallbackType="user"
                height={80}
              />
              <Column rowGap={10} justifyContent="center">
                <Typography
                  content={
                    appointmentConsultDashboard?.nextScheduleAppointment
                      ?.patient?.name
                  }
                  size={14}
                />
                <Row colGap={10}>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextScheduleAppointment
                        ?.patient?.infos?.gender
                    }
                  </StyleTag>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextScheduleAppointment
                        ?.patient?.infos?.age
                    }
                  </StyleTag>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextScheduleAppointment
                        ?.patient?.infos?.bloodGroup
                    }
                  </StyleTag>
                </Row>
              </Column>
            </StyleLeftWrapper>
            <StyleRightWrapper>
              <ScheduleCard />
              <Button
                leftComponent={<Svg svg="message" color={'primary'} />}
                title="Message Now"
                outline
                height={45}
                onClick={handleClickMessage}
              />
              <Button
                title="View Details"
                height={45}
                onClick={handleClickViewDetails}
              />
            </StyleRightWrapper>
          </StyleCard>
        </StyleColumn>
      ) : (
        <></>
      )}
    </>
  )
}

export default NextScheduleAppointment
